import React from 'react';
import ButtonsSearch from '../../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../../components/NovoSistema/InputText';
import DoubleInput from '../../../../../../../components/NovoSistema/DoubleInput';
import SelectAndOptions from '../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function RequisicaoDeMaterialSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <InputText title="Número Documento Inicial" id="NumeroDocumentoInicial" widthPercentage="20%" />
          <InputText title="Número Documento Final" id="NumeroDocumentoFinal" widthPercentage="20%" />
          <InputDate title="Emissão Inicial" id="EmissaoInicial" widthPercentage="20%" />
          <InputDate title="Emissão Final" id="EmissaoFinal" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <DoubleInput title="Produto" id="Produto" widthPercentage="40%" />
          <InputDate title="Previsão de Entrega Inicial" id="PrevisaoDeEntregaInicial" widthPercentage="20%" />
          <InputDate title="Previsão de Entrega Final" id="PrevisaoDeEntregaFinal" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <SelectAndOptions title="Setor" id="Setor" optionsArray={['']} widthPercentage="40%" />
          <SelectAndOptions
            title="Situação"
            id="Situacao"
            optionsArray={[
              '',
              'Todas',
              'Aberta',
              'Finalizada Parcialmente',
              'Finalizada',
              'Finalizada Manualmente',
              'Cancelada',
            ]}
            widthPercentage="40%"
          />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
    </div>
  );
}
